import React from "react";
import { Link } from "react-router-dom";
import { Table } from "react-bootstrap";
import { notApplicableItems } from "../../../constants/constants-container";
import { observer, inject } from "mobx-react";
import CellContent from "./../template/CellContent";
import EntityDetailsModal from "../../../modal-views/EntityDetailsModal";
import { StoreContext } from "../../../contexts/StoreContext";

import "./MappingDefinition.scss";
@inject("detailViewStore", "popupStore")
@observer
class MappingDefinition extends React.Component {
  state = {
    showVariableDetailsModal: false,
    showAll: false,
    variableToshow: null,
  };
  getHeader = (entityData) => {
    if (
      !entityData ||
      !entityData.navigationLookupResult ||
      !entityData.navigationLookupResult.navigationLookupRootItem ||
      !entityData.navigationLookupResult.navigationLookupRootItem.items ||
      !entityData.navigationLookupResult.navigationLookupRootItem.items.length
    )
      return;

    const variableMapping =
      entityData.navigationLookupResult.navigationLookupRootItem.items.find(
        (item) => item.object && item.object.type === "VariableMapping"
      );
    if (
      !variableMapping ||
      !variableMapping.items ||
      !variableMapping.items.length
    )
      return;
    const variableMappingItems = variableMapping.items.filter(
      (item) => item.object && item.object.type === "VariableMappingItem"
    );
    const source = variableMappingItems.filter(
      (vmi) => vmi.object && vmi.object.isSource === true
    );
    const target = variableMappingItems.filter(
      (vmi) => vmi.object && vmi.object.isSource === false
    );
    if (!source || !source.length || !target || !target.length) return;
    const mapItems = (array) => {
      return array.map((item) => {
        if (
          !item.object ||
          !item.items ||
          !item.items.length ||
          !item.items[0].object
        )
          return {};
        return {
          variableId: item.object.variableId,
          code: item.items[0].object.code,
          name: item.items[0].object.name,
          type: item.items[0].object.type,
          tid: item.items[0].object.tid,
          maintenanceAgencyId: item.items[0].object.maintenanceAgencyId,
        };
      });
    };
    const header = [...mapItems(source), {}, ...mapItems(target)];
    return header;
  };

  getRows = (entityData, header) => {
    if (
      !entityData ||
      !entityData.navigationLookupResult ||
      !entityData.navigationLookupResult.navigationLookupRootItem ||
      !entityData.navigationLookupResult.navigationLookupRootItem.items ||
      !entityData.navigationLookupResult.navigationLookupRootItem.items.length
    )
      return;

    const memberMapping =
      entityData.navigationLookupResult.navigationLookupRootItem.items.find(
        (item) => item.object && item.object.type === "MemberMapping"
      );
    if (!memberMapping || !memberMapping.items || !memberMapping.items.length)
      return;
    const memberMappingItems = memberMapping.items.filter(
      (item) => item.object && item.object.type === "MemberMappingItem"
    );
    const members = memberMappingItems.map((item) => {
      if (
        !item.object ||
        !item.items ||
        !item.items.length ||
        !item.items[0].object
      )
        return {};
      return {
        variableId: item.object.variableId,
        mappingRow: item.object.memberMappingRow,
        code: item.items[0].object.code,
        name: item.items[0].object.name,
        type: item.items[0].object.type,
        tid: item.items[0].object.tid,
        maintenanceAgencyId: item.items[0].object.maintenanceAgencyId,
      };
    });

    const groupBy = function (xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    };

    const groupedMembersByRow = groupBy(members, "mappingRow");

    const rows = Object.keys(groupedMembersByRow)
      .map((key) => groupedMembersByRow[key])
      .map((row) => {
        const cells = [];
        header.forEach((h) => {
          if (!h.variableId) {
            cells.push({});
          } else {
            const cell = row.find(
              (r) => r.variableId === h.variableId || r.variableId === "*"
            );
            if (cell) {
              cells.push(cell);
            }
          }
        });
        return cells;
      });

    const filteredRows = rows;
    /* const filteredRows = rows.filter((row) => {
      const names = row.map((cell) => cell.name);
      return names.every(
        (name) => name === undefined || !notApplicableItems.includes(name)
      );
    }); */

    return filteredRows;
  };

  handleToggleVariableDetailsModal = (e, detailsItem) => {
    e?.preventDefault();
    this.setState((oldState) => ({
      ...oldState,
      showVariableDetailsModal: !oldState.showVariableDetailsModal,
      variableToshow: detailsItem,
    }));
    return false;
  };

  exportToExcel = (entityData) => {
    const { detailViewStore } = this.props;
    const tid = entityData.object.tid;
    detailViewStore.exportMappingDefinition([tid]);
  };

  render() {
    const { entityData } = this.props;
    const { variableToshow } = this.state;

    const header = this.getHeader(entityData) || [];
    const rows = this.getRows(entityData, header) || [];

    return (
      <div className="mapping custom-panel">
        <div className="custom-panel-heading">
          <h4>Member Mappings</h4>
          <div className="custom-export-alignament">
            <h5>Excel export</h5>
            <span
              className="glyphicon glyphicon-download-alt"
              style={{ float: "right", cursor: "pointer" }}
              onClick={() => this.exportToExcel(entityData)}
            ></span>
          </div>
        </div>
        <div className="custom-panel-body">
          <div className="item-list-container template-table-container">
            <Table
              striped
              bordered
              condensed
              hover
              className="mapping-definition-table"
            >
              <thead>
                <tr>
                  {header.map((item, index) => (
                    <th
                      key={index}
                      className={`${!item.variableId ? "separator" : ""} ${
                        item.maintenanceAgencyId === "ECB"
                          ? "reference"
                          : "non-reference"
                      }`}
                    >
                      {item.variableId ? (
                        <CellContent
                          content={item.name + " (" + item.code + ")"}
                          id={0}
                          maxLength={60}
                        />
                      ) : (
                        "->"
                      )}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {row.map((cell, cellIndex) => (
                      <td
                        key={`${rowIndex}-${cellIndex}`}
                        className={`${!cell.variableId ? "separator" : ""} ${
                          cell.name && notApplicableItems.includes(cell.name)
                            ? "na"
                            : ""
                        }`}
                      >
                        {cell.name && cell.code ? (
                          <Link
                            onClick={(e) => {
                              this.handleToggleVariableDetailsModal(e, cell);
                            }}
                            to={`/view/${cell.type}/${cell.tid}`}
                            target="_blank"
                          >
                            {cell.name} ({cell.code})
                          </Link>
                        ) : null}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
        {this.state.showVariableDetailsModal && (
          <StoreContext.Provider value={this.props.popupStore}>
            <EntityDetailsModal
              details={variableToshow ? variableToshow : rows[0][0]}
              onClose={(e) => {
                this.handleToggleVariableDetailsModal(e, rows[0][0]);
              }}
            />
          </StoreContext.Provider>
        )}
      </div>
    );
  }
}

export default MappingDefinition;
